import { Box, Grid, IconButton } from '@material-ui/core';

import { usePassengersForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Flight/components/FlightForm/hooks/usePassengersForm';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const PassengersForm = () => {
  const { passengerFields, passengerAppend, passengerRemove, classes } = usePassengersForm();

  return (
    <>
      <Box mt={4} mb={2}>
        <Font variant="h4" color="textPrimary">
          <Text strong tId={'PASSENGERS_DETAILS'} />
        </Font>
      </Box>
      <Grid container spacing={2}>
        {passengerFields.map((field, i) => {
          return (
            <Grid item xs={12} key={i}>
              <TextFormField
                key={field.id}
                name={`item.passengers.${i}.documentNumber`}
                label={'PASSENGER_DOCUMENT_NUMBER'}
                labelDynamicDataTexts={[i + 1]}
                InputProps={{
                  endAdornment: i !== 0 && (
                    <IconButton style={{ padding: 3, top: -2 }} onClick={() => passengerRemove(i)}>
                      {<Icon size={22}>delete</Icon>}
                    </IconButton>
                  ),
                  classes: classes,
                }}
                fieldVariant={FieldVariant.form}
              />
            </Grid>
          );
        })}
      </Grid>
      <StandardButton
        onClick={() => passengerAppend({ documentNumber: '' })}
        startIcon={<Icon size={22}>add</Icon>}
        style={{ marginTop: '8px' }}
      >
        <Text tId={'ADD_ANOTHER_PASSENGER'} />
      </StandardButton>
    </>
  );
};
